import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * Vive dentro del grupo `_contabilidad`, así que el guardián ya se aplicó y esta ruta no repite
 * ninguna verificación.
 *
 * EL GRUPO ES EL CORRECTO Y SE COMPROBÓ CONTRA LA MATRIZ, no contra el tema de la pantalla. La
 * acción del escenario es `periodo.cerrar`, que en la matriz de la feature 2 son el contador y el
 * administrador; `_contabilidad` exige `utilidad.ver`, que son exactamente esos dos. Adjudicación
 * 177. Reabrir es otra cosa y no está acá: `periodo.reabrir` es solo del administrador.
 *
 * El componente llega a pedido, como los demás hijos de este grupo: arrastra `@tanstack/query`, el
 * panel y la bitácora del mes, y ninguno de los dos roles de operación descarga nada de eso.
 */
export const rutaCierrePeriodo = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/cierre-periodo',
  component: lazyRouteComponent(() => import('./cierre-periodo-pantalla.js'), 'RutaCierrePeriodo'),
});
